const AppConfigs = {
    serverConfig: {
        host: process.env.REACT_APP_HOST,
        port: process.env.REACT_APP_PORT, 
        defaultRoute: 'RFID/v1/api',
        user: 'user',
        serverUrl: process.env.REACT_APP_SERVER_URL,
    }
};

export const defaultSnackbarTimeout = 5000;

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY

export default AppConfigs;